import PosthogService from '~/services/posthog/PosthogService';
import { REDESIGN_SIGNUP_DESIGN_DATE } from '~/services/posthog/events';

/**
 * Fires when the user clicks the "Professional" tab on the sign up page.
 * Event: dental_portal:office_signup:professional_tab_clicked
 */
export function fireProfessionalTabClicked(): void {
  PosthogService.getInstance().track('dental_portal:office_signup:professional_tab_clicked', {
    design_date: REDESIGN_SIGNUP_DESIGN_DATE,
  });
}
